/**
 * this file contains all redux-saga watchers & workers for the latest news
 * - watchers watch for dispatched actions
 * - workers invoke another actions in response to the processed actions
 *
 * NOTE: Saga's use the new ES6 generator functions function* ()
 * NOTE: Arrow-function can not be used as generators as the yield keyword
 * may not work in an arrow function's body
 *
 * Created by Min on 11/09/18
 */

import { takeEvery, call, put } from 'redux-saga/effects'

import C from '../constants'
import config from '../config'
import { request, isEmpty } from '../utility/utilities'

// import action creators
import * as NewsActions from '../actions/newsActions'

/* -----------------------------------------------------------------------------
    WATCHER & WORKER SAGA TO FETCH THE NEWS DATA
----------------------------------------------------------------------------- */

// watcher saga for fetching the news data
export function* watchFetchNewsData() {
    yield takeEvery(C.FETCH_NEWS_DATA, workerFetchNews)
}

// worker saga for fetching the fund data
function* workerFetchNews() {
    // set the headers
    const headers = {
        method: 'GET',
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
        },
        mode: 'cors',
        cache: 'default'
    }

    // set the endpoint
    const requestURL = config.endpoints.newsFetchURL

    try {

        // show the loader
        yield put(NewsActions.showNewsLoader(true))

        // get the response promise object
        const response = yield call(request, requestURL, headers)

        if(!isEmpty(response.data)) {

            // set the news data
            yield put(NewsActions.setNewsData(response.data))
        }

    } catch (error) {

    } finally {
        // hide the loader regardless
        yield put(NewsActions.showNewsLoader(false))
    }
}



// WEBPACK FOOTER //
// ./src/sagas/latestnewsSaga.js